
import React from 'react'
import { useUpdateEffect } from 'ahooks';
import Router from './router'
import { userStore } from './store';
import useAppService from './useAppService'

export default function App() {

    const { runTheme, } = useAppService(true);

    const { lineId } = userStore;

    useUpdateEffect(() => {
        if (lineId) {
            runTheme()
        }
    }, [lineId])


    return <Router />

}
